<template>
   <v-dialog v-model="dialog"  persistent width="300">
          <v-card flat color="primary" dark>
            <v-card-text>
              {{text? text : $t('wait1')}}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
</template>

<script>
export default {
props: {
    dialog: Boolean,
    text: String,
  },
  data() {
    return {
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/LoadingDialog.vue